module.exports = __webpack_public_path__ + "static/image/font/pc/kkubulim-4.ver2_0_2.png?01405b67";